import {
    ActionReducerMap,
} from '@ngrx/store';
import * as fromAuth from '../auth/store/auth.reducer';
import * as fromCompany from '../components/company/store/company.reducer';
import * as fromAssignments from '../components/assignments/store/assignments.reducer';
import * as fromShared from '../shared-store/shared.reducer';

export interface AppState {
    auth: fromAuth.State;
    company: fromCompany.State;
    assignments: fromAssignments.State;
    shared: fromShared.State;
}

export const appReducer: ActionReducerMap<AppState> = {
    auth: fromAuth.authReducer,
    company: fromCompany.companyReducer,
    assignments: fromAssignments.assignmentsReducer,
    shared: fromShared.sharedReducer,
};

